import type { InventoryItem, OrderItem } from '@/types/schemas';

export type CartLine = OrderItem;

export function addItemToCart(cart: CartLine[], it: InventoryItem): CartLine[] {
  const existing = cart.find((c) => c.itemId === it.id);
  if (existing) {
    if (existing.quantity + 1 > it.quantity) return cart;
    return cart.map((c) =>
      c.itemId === it.id
        ? { ...c, quantity: c.quantity + 1, total: (c.quantity + 1) * c.price }
        : c,
    );
  }
  if (it.quantity < 1) return cart;
  return [
    ...cart,
    {
      itemId: it.id,
      itemName: it.itemName,
      sku: it.sku,
      price: it.sellingPrice,
      quantity: 1,
      total: it.sellingPrice,
    },
  ];
}

export function changeCartQty(
  cart: CartLine[],
  itemId: string,
  delta: number,
): CartLine[] {
  return cart
    .map((c) =>
      c.itemId === itemId
        ? {
            ...c,
            quantity: Math.max(0, c.quantity + delta),
            total: Math.max(0, c.quantity + delta) * c.price,
          }
        : c,
    )
    .filter((c) => c.quantity > 0);
}

export function removeFromCart(cart: CartLine[], itemId: string): CartLine[] {
  return cart.filter((c) => c.itemId !== itemId);
}

export function computeTotals(
  cart: CartLine[],
  deliveryCharge: number,
  discount: number,
) {
  const subtotal = cart.reduce((s, c) => s + c.total, 0);
  const total = Math.max(0, subtotal + deliveryCharge - discount);
  return { subtotal, total };
}
